import script from "./VideoView.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoView.vue?vue&type=script&setup=true&lang=js"

import "./VideoView.vue?vue&type=style&index=0&id=22e4df45&lang=css"

const __exports__ = script;

export default __exports__